import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IOTP } from '../OTP';

export interface ICompleteOTPVariables {
    id: number;
    reasonCode?: number;
    reasonText?: string;
}

export function useCompleteOTP(patientId?: number) {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<IOTP, AppMedError, ICompleteOTPVariables>({
        mutationKey: [QueryKeys.otp, 'complete'],
        mutationFn: async ({ id, reasonCode, reasonText }: ICompleteOTPVariables) => {
            return await OTPApi.completeOTP(id, reasonCode, reasonText);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.otp] });
            if (patientId) 
                queryClient.invalidateQueries({ queryKey: [QueryKeys.otpByPatient, patientId] });
            
            notifications.show({
                title: t('otp.notifications.completeSuccess.title'),
                message: t('otp.notifications.completeSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('otp.notifications.completeError.title'),
                message: error?.message || t('otp.notifications.completeError.message'),
                color: 'red',
            });
        },
    });
}
